import { Box, Separator, Shimmer, ShimmerText } from '@betterment/samba-react';

const TITLE_WIDTH = '40%';
const LABEL_WIDTH = '50%';
const BALANCE_WIDTH = '40%';
const INPUT_HEIGHT = '50px';

const FormFieldShimmer: React.FC = () => (
  <Box css={{ display: 'flex', flexDirection: 'column', gap: 'space.100' }}>
    <ShimmerText textStyle="title100" css={{ maxWidth: LABEL_WIDTH }} />
    <Shimmer css={{ width: '100%', height: INPUT_HEIGHT }} />
  </Box>
);

const PlanSettingsShimmer: React.FC = () => {
  return (
    <Box data-testid="planSettingsShimmer" css={{ display: 'flex', flexDirection: 'column', gap: 'space.300' }}>
      <Box css={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <ShimmerText textStyle="text100" css={{ maxWidth: TITLE_WIDTH }} />
        <ShimmerText textStyle="text50" css={{ maxWidth: '20%' }} />
      </Box>
      <Box css={{ display: 'flex', flexDirection: 'column', gap: 'space.50' }}>
        <ShimmerText textStyle="text50" css={{ maxWidth: LABEL_WIDTH }} />
        <ShimmerText textStyle="text50" css={{ maxWidth: BALANCE_WIDTH }} />
      </Box>
      <Box css={{ display: 'flex', flexDirection: 'column', gap: 'space.50' }}>
        <ShimmerText textStyle="text50" css={{ maxWidth: LABEL_WIDTH }} />
        <ShimmerText textStyle="text50" css={{ maxWidth: BALANCE_WIDTH }} />
      </Box>
    </Box>
  );
};

interface Props {
  withPlanSettings?: boolean;
}

export const ForecasterSettingsLoadingState: React.FC<Props> = ({ withPlanSettings = false }: Props) => {
  return (
    <Box role="status" aria-label="Loading..." css={{ display: 'flex', flexDirection: 'column', gap: 'space.300' }}>
      <FormFieldShimmer />
      <FormFieldShimmer />
      {withPlanSettings && (
        <>
          <Separator />
          <PlanSettingsShimmer />
        </>
      )}
    </Box>
  );
};
